/**
 * Welcome Kit sync — ensures Buy 1/2/3 always get the matching Welcome Kit
 * product in cart, and strips Kaching individual free gifts.
 *
 * Jacked.com (t14v0k-nw) only. JackedInfo uses assets/info-hero-gifts-sync.js.
 */
(function () {
  if (window.__JCKED_WK_SYNC__) return;
  window.__JCKED_WK_SYNC__ = true;

  var shop = (window.Shopify && window.Shopify.shop) || '';
  // Info store: Cookbook + Shred gifts — do not strip free Shred / inject main-store kits
  if (shop === 'd5i265-tx.myshopify.com') return;

  var PACK_HANDLE_MATCH = 'liquid-l-carnitine';
  var KIT = {
    1: { handle: 'jcked-welcome-kit-buy-1', variantId: 44528827531307 },
    2: { handle: 'jcked-welcome-kit-buy-2', variantId: 44528827662379 },
    3: { handle: 'jcked-welcome-kit-buy-3', variantId: 44528827695147 },
  };
  var INDIVIDUAL_GIFTS = [
    '7x-l-carnitine-travel-sachets',
    'advance-protocol-shaker',
    'microfiber-gym-towel',
    'jcked-welcome-kit',
  ];
  var FREE_ONLY_GIFTS = ['jcked-100-day-shred-program'];
  var ALL_KIT_HANDLES = Object.keys(KIT).map(function (k) {
    return KIT[k].handle;
  });

  var syncing = false;
  var queued = false;
  var inflight = 0;
  var selfRequest = false;
  var lastAddAttempt = 0;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(String(url || ''));
  }

  function isFree(item) {
    return Number(item.final_line_price) === 0 || Number(item.price) === 0;
  }

  function shouldStrip(item) {
    var handle = item.handle || '';
    if (INDIVIDUAL_GIFTS.indexOf(handle) !== -1) return true;
    if (FREE_ONLY_GIFTS.indexOf(handle) !== -1 && isFree(item)) return true;
    return false;
  }

  function paidBottles(cart) {
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      var handle = String(item.handle || '').toLowerCase();
      if (handle.indexOf(PACK_HANDLE_MATCH) === -1) return;
      if (ALL_KIT_HANDLES.indexOf(item.handle) !== -1) return;
      if (INDIVIDUAL_GIFTS.indexOf(item.handle) !== -1) return;
      if (isFree(item)) return;
      qty += Number(item.quantity) || 0;
    });
    return qty;
  }

  function tierFor(qty) {
    if (qty >= 3) return 3;
    if (qty >= 2) return 2;
    if (qty >= 1) return 1;
    return 0;
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (t) {
          throw new Error(url + ' → ' + res.status + ' ' + t);
        });
      }
      return res.json();
    });
  }

  function getCart() {
    return fetchJSON(root() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });
  }

  function own(fn) {
    selfRequest = true;
    return Promise.resolve()
      .then(fn)
      .finally(function () {
        setTimeout(function () {
          selfRequest = false;
        }, 0);
      });
  }

  function updateCart(updates) {
    return own(function () {
      return fetchJSON(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates }),
      });
    });
  }

  function addKit(variantId) {
    lastAddAttempt = Date.now();
    return own(function () {
      return fetchJSON(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: { _welcome_kit: 'true', _hide: 'true' },
            },
          ],
        }),
      });
    });
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'welcome-kit-sync' } }));
      return Promise.resolve();
    }
    return fetchJSON(root() + '?sections=cart-drawer', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (data) {
        if (data['cart-drawer']) drawer.renderContents({ sections: data });
      })
      .catch(function () {})
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'welcome-kit-sync' } }));
      });
  }

  function sync() {
    if (inflight > 0) {
      queued = true;
      schedule(500);
      return;
    }
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;

    getCart()
      .then(function (cart) {
        var tier = tierFor(paidBottles(cart));
        var target = tier ? KIT[tier] : null;
        var updates = {};
        var needsUpdate = false;
        var hasTarget = false;

        (cart.items || []).forEach(function (item) {
          var handle = item.handle || '';
          var key = String(item.key || '');
          if (!key) return;

          if (shouldStrip(item)) {
            updates[key] = 0;
            needsUpdate = true;
            return;
          }

          if (ALL_KIT_HANDLES.indexOf(handle) !== -1) {
            if (!target) {
              updates[key] = 0;
              needsUpdate = true;
              return;
            }
            if (handle === target.handle) {
              hasTarget = true;
              if (Number(item.quantity) !== 1) {
                updates[key] = 1;
                needsUpdate = true;
              }
            } else {
              updates[key] = 0;
              needsUpdate = true;
            }
          }
        });

        var needsAdd = !!(target && !hasTarget);
        if (!needsUpdate && !needsAdd) return null;

        var chain = Promise.resolve();
        if (needsUpdate) {
          chain = chain.then(function () {
            return updateCart(updates);
          });
        }
        if (needsAdd) {
          chain = chain.then(function () {
            // Re-read cart in case another request already added the kit
            return getCart().then(function (fresh) {
              var already = (fresh.items || []).some(function (i) {
                return i.handle === target.handle;
              });
              if (already) return null;
              return addKit(target.variantId);
            });
          });
        }
        return chain.then(function () {
          return refreshDrawer();
        });
      })
      .catch(function (err) {
        console.warn('[welcome-kit-sync]', err);
        // Retry shortly after a failed add
        schedule(1500);
      })
      .finally(function () {
        syncing = false;
        if (queued) {
          queued = false;
          schedule(400);
        }
      });
  }

  function schedule(ms) {
    clearTimeout(schedule._t);
    schedule._t = setTimeout(sync, typeof ms === 'number' ? ms : 700);
  }

  function onMutationEnd() {
    inflight = Math.max(0, inflight - 1);
    schedule(600);
  }

  function track(url, promise) {
    if (selfRequest) return;
    if (!isMutation(url)) return;
    inflight += 1;
    if (promise && typeof promise.then === 'function') {
      promise.then(onMutationEnd, onMutationEnd);
    } else {
      setTimeout(onMutationEnd, 800);
    }
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    track(url, p);
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__jckUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (!selfRequest && isMutation(xhr.__jckUrl)) {
      inflight += 1;
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        onMutationEnd();
      };
      xhr.addEventListener('loadend', finish);
    }
    return _send.apply(this, arguments);
  };

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.source === 'welcome-kit-sync') return;
    schedule(700);
  });
  document.addEventListener('theme:cart:change', function () {
    schedule(700);
  });

  // Buy-box ATC often uses custom buttons — cast a wide net
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (
        t.closest(
          'button[name="add"], [name="add"], .product-form__submit, .add-to-cart, [data-add-to-cart], .ajax-cart__buttons, form[action*="/cart/add"] button'
        )
      ) {
        // Burst retries after ATC — Kaching gifts land late
        schedule(800);
        setTimeout(function () {
          schedule(0);
        }, 1600);
        setTimeout(function () {
          schedule(0);
        }, 3200);
      }
    },
    true
  );

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__jckObserved) return;
    drawer.__jckObserved = true;
    new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.hasAttribute('open')) schedule(500);
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchDrawer();
      schedule(800);
    });
  } else {
    watchDrawer();
    schedule(800);
  }

  window.JCKEDWelcomeKitSync = { sync: sync, schedule: schedule };
})();
